/*
 * Fig & Bloom — mobile delivery picker-start.
 *
 * Native adoption of Mida experiment 36382 Variant 1. The test has ended,
 * so this file does not send a PostHog arm event.
 *
 * Part A (product pages, not osaka / marseille / broome): keep the
 * "Delivering where & when?" row in snippets/fb-dp-prompt.liquid in step
 * with the delivery card, and forward a tap to that card's own suburb or
 * date button. No add-to-cart, validation, or cart change.
 *
 * Part B (/collections/flowers, max-width 749px): once the category chips
 * are stuck and the header delivery bar has scrolled above them, show
 * snippets/fb-dp-pin.liquid under the chips, but only while the shopper is
 * scrolling up. The direction comes from the header's own hide/reveal
 * script (snippets/delivery-suburb-header-form.liquid), which adds
 * .delivery-suburb-hidden to .header-delivery-section on scroll-down and
 * removes it on scroll-up or near the top. The pin follows that class, so
 * it hides and reveals on exactly the same scroll as the header bar does
 * everywhere else. Each pin pill clicks the theme pill it mirrors. The bar
 * hides while #popupModal is open. Keeping the in-flow bar from collapsing
 * (no layout jump) is CSS, in assets/fb-dp.css.
 */
(function () {
  if (window.__fbDp) return;
  window.__fbDp = true;
  /* Stand a still-cached experiment script down. CSS hides its nodes. */
  window.__fbDpPrompt = true;
  window.__fbDpPin = true;

  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;

  if (document.body && document.body.classList.contains('fb-dp-flowers')) {
    initPin();
  }

  if (!/\/products\//.test(location.pathname)) return;
  if (/\/products\/(osaka|marseille|broome)/.test(location.pathname)) return;
  initPrompt();

  function initPin() {
    var bar = null;
    var src = null;
    var chips = null;
    var ticking = false;
    var hideTimer = null;
    /* Last scrollY at which the pin was on and the header said "up". A
       scroll-down only hides the pin once the page has moved more than
       JITTER px below that, so a 1px scroll-anchoring nudge right after a
       reveal cannot blink it off under a tap. A real scroll-down passes 8px
       within a frame or two. HIDE_MS matches the fade in assets/fb-dp.css. */
    var shownAt = null;
    var JITTER = 8;
    var HIDE_MS = 120;

    function scrollY() {
      var y = window.pageYOffset;
      if (typeof y !== 'number') {
        var root = document.documentElement;
        y = root && typeof root.scrollTop === 'number' ? root.scrollTop : 0;
      }
      return y;
    }

    function visibleForm(sec) {
      var forms = sec.querySelectorAll('.header-delivery-form');
      for (var i = 0; i < forms.length; i++) {
        if (forms[i].style.display !== 'none') return forms[i];
      }
      return forms[0] || null;
    }

    function sync() {
      if (!bar || !src) return;
      var form = visibleForm(src);
      if (!form) return;
      var pills = form.querySelectorAll('.header-delivery-pill');
      var mine = bar.querySelectorAll('.header-delivery-pill');
      for (var i = 0; i < mine.length; i++) {
        var original = pills[i];
        var copy = mine[i];
        if (!original) {
          copy.style.display = 'none';
          continue;
        }
        copy.style.display = '';
        copy.setAttribute('data-target', original.id || '');
        copy.classList.toggle('has-value', original.classList.contains('has-value'));
        var originalText = original.querySelector('.header-delivery-pill-text');
        var copyText = copy.querySelector('.header-delivery-pill-text');
        var text = originalText ? (originalText.textContent || '').replace(/\s+/g, ' ').trim() : '';
        if (copyText && copyText.textContent !== text) copyText.textContent = text;
        var originalLabel = original.querySelector('.header-delivery-pill-label');
        copy.setAttribute('aria-label', ((originalLabel ? originalLabel.textContent.trim() + ' ' : '') + text).trim());
      }
    }

    function build() {
      bar = document.createElement('div');
      bar.id = 'fb-dp-pin';
      bar.className = 'fb-dpin';
      bar.setAttribute('aria-hidden', 'true');
      var pin = '<svg class="header-delivery-pill-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5z" fill="currentColor"/></svg>';
      var cal = '<svg class="header-delivery-pill-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15" rx="2" stroke="currentColor" stroke-width="1.8"/><path d="M3.5 10h17M8 3v4M16 3v4" stroke="currentColor" stroke-width="1.8"/></svg>';
      bar.innerHTML = '<button type="button" class="header-delivery-pill fb-dpin__pill ph-no-capture ph-sensitive" tabindex="-1">' + pin + '<span class="header-delivery-pill-text"></span></button>' +
        '<button type="button" class="header-delivery-pill fb-dpin__pill" tabindex="-1">' + cal + '<span class="header-delivery-pill-text"></span></button>';
      document.body.appendChild(bar);
      bindPin();
    }

    function bindPin() {
      if (!bar || bar.getAttribute('data-fb-dp-bound') === '1') return;
      bar.setAttribute('data-fb-dp-bound', '1');
      bar.addEventListener('click', function (e) {
        var button = e.target && e.target.closest ? e.target.closest('.fb-dpin__pill') : null;
        if (!button) return;
        e.preventDefault();
        var id = button.getAttribute('data-target');
        var original = id ? document.getElementById(id) : null;
        if (original && typeof original.click === 'function') original.click();
      });
    }

    function setOn(on, top) {
      if (!bar) return;
      if (on) bar.style.top = top + 'px';
      if (bar.classList.contains('is-on') === on) return;
      /* Hit-testing comes back with the class, on the first frame of the
         reveal. On hide, .is-hiding keeps the pin tappable until the fade has
         finished; only then does visibility / pointer-events drop. */
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (on) {
        bar.classList.remove('is-hiding');
      } else {
        bar.classList.add('is-hiding');
        hideTimer = setTimeout(function () {
          hideTimer = null;
          if (!bar.classList.contains('is-on')) bar.classList.remove('is-hiding');
        }, HIDE_MS);
      }
      shownAt = on ? scrollY() : null;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var buttons = bar.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) buttons[i].tabIndex = on ? 0 : -1;
    }

    function update() {
      ticking = false;
      if (!bar || !src) return;
      if (MQ && !MQ.matches) {
        setOn(false);
        return;
      }
      var popup = document.getElementById('popupModal');
      if (popup && popup.style.display && popup.style.display !== 'none') {
        setOn(false);
        return;
      }
      if (!chips || !document.contains(chips)) chips = document.querySelector('.collection-nav-wrapper');
      var stuck = !!(chips && chips.classList.contains('is-stuck'));
      var top = stuck ? Math.max(0, Math.round(chips.getBoundingClientRect().bottom)) : 0;
      var srcGone = src.getBoundingClientRect().bottom <= top;
      /* Same signal the header uses to collapse its bar: set on scroll-down,
         cleared on scroll-up. Without it the pin stayed on while scrolling
         down and covered the product cards. */
      var scrollingDown = src.classList.contains('delivery-suburb-hidden');
      if (bar.classList.contains('is-on') && stuck && srcGone) {
        var y = scrollY();
        if (shownAt === null || !scrollingDown) shownAt = y;
        if (scrollingDown && y - shownAt <= JITTER) scrollingDown = false;
      }
      setOn(stuck && srcGone && !scrollingDown, top);
    }

    function req() {
      if (ticking) return;
      ticking = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(update);
      else setTimeout(update, 16);
    }

    function boot(tries) {
      src = document.querySelector('.header-delivery-section');
      if (!src || !document.body) {
        if (tries > 0) setTimeout(function () { boot(tries - 1); }, 250);
        return;
      }
      if (src.hasAttribute('data-homepage-delivery')) return;
      bar = document.getElementById('fb-dp-pin');
      if (!bar) build();
      else bindPin();
      sync();
      if (window.MutationObserver) {
        new MutationObserver(function () { sync(); req(); }).observe(src, {
          childList: true,
          characterData: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        chips = document.querySelector('.collection-nav-wrapper');
        if (chips) new MutationObserver(req).observe(chips, { attributes: true, attributeFilter: ['class', 'style'] });
        var popup = document.getElementById('popupModal');
        if (popup) new MutationObserver(req).observe(popup, { attributes: true, attributeFilter: ['style'] });
      }
      window.addEventListener('scroll', req, { passive: true });
      window.addEventListener('resize', req);
      update();
    }

    boot(20);
  }

  function initPrompt() {
    var ID = 'fb-dp-prompt';
    var DEFAULT_SUBURB = /^\s*(enter suburb or postcode)?\s*$/i;
    var DEFAULT_DATE = /^\s*(select)?\s*$/i;
    var observed = null;

    function q(sel, root) {
      try { return (root || document).querySelector(sel); } catch (e) { return null; }
    }

    function txt(el) {
      return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function parts() {
      var info = q('.product__info-container');
      if (!info) return null;
      var suburbButton = q('[id^="dc-suburb-btn-"]', info);
      var dateButton = q('[id^="dc-date-btn-"]', info);
      if (!suburbButton) return null;
      if (!q('.fbg-variant-picker, variant-radios', info)) return null;
      var anchor = q('.product__tax', info) || q('.price__box_wrapper', info);
      if (!anchor || !anchor.parentNode) return null;
      return {
        info: info,
        suburbButton: suburbButton,
        dateButton: dateButton,
        anchor: anchor,
        suburbText: q('[id^="dc-suburb-text-"]', info),
        dateText: q('[id^="dc-date-text-"]', info)
      };
    }

    function state(found) {
      var suburb = txt(found.suburbText);
      var date = txt(found.dateText);
      var hasSuburb = suburb && !DEFAULT_SUBURB.test(suburb);
      var hasDate = date && !DEFAULT_DATE.test(date);
      return { suburb: hasSuburb ? suburb : '', date: hasDate ? date : '' };
    }

    function render(found, row) {
      var current = state(found);
      var main = row.querySelector('.fb-dpp__main');
      var cta = row.querySelector('.fb-dpp__cta');
      if (!main || !cta) return false;
      if (!current.suburb) {
        main.textContent = 'Delivering where & when?';
        cta.textContent = 'Enter suburb or postcode \u203A';
        row.setAttribute('data-state', 'empty');
      } else if (!current.date) {
        main.textContent = 'Delivering to ' + current.suburb;
        cta.textContent = 'Choose a date \u203A';
        row.setAttribute('data-state', 'suburb');
      } else {
        main.textContent = 'Delivering to ' + current.suburb + ' \u00B7 ' + current.date;
        cta.textContent = 'Change \u203A';
        row.setAttribute('data-state', 'complete');
      }
      return true;
    }

    function hide(row) {
      if (!row) return;
      row.classList.remove('is-on');
    }

    function onClick(e) {
      e.preventDefault();
      var found = parts();
      if (!found) return;
      var current = state(found);
      var target = (current.suburb && found.dateButton) ? found.dateButton : found.suburbButton;
      if (target && typeof target.click === 'function') target.click();
    }

    function build() {
      var row = document.createElement('button');
      row.type = 'button';
      row.id = ID;
      row.className = 'fb-dpp ph-no-capture ph-sensitive';
      row.setAttribute('aria-label', 'Set delivery suburb and date');
      row.innerHTML = '<span class="fb-dpp__icon" aria-hidden="true">\uD83D\uDCCD</span>' +
        '<span class="fb-dpp__main"></span><span class="fb-dpp__cta"></span>';
      return row;
    }

    function ensure() {
      var row = document.getElementById(ID);
      var found = parts();
      if (!found) {
        hide(row);
        return false;
      }
      if (!row) {
        row = build();
        found.anchor.parentNode.insertBefore(row, found.anchor.nextSibling);
      }
      if (row.getAttribute('data-fb-dp-bound') !== '1') {
        row.setAttribute('data-fb-dp-bound', '1');
        row.addEventListener('click', onClick);
      }
      if (!render(found, row)) return false;
      row.classList.add('is-on');
      var card = found.suburbButton.closest ? found.suburbButton.closest('.delivery-card') : null;
      if (card && observed !== card && window.MutationObserver) {
        observed = card;
        var timer = null;
        new MutationObserver(function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var currentRow = document.getElementById(ID);
            var currentParts = parts();
            if (currentRow && currentParts) render(currentParts, currentRow);
          }, 50);
        }).observe(card, { childList: true, characterData: true, subtree: true });
      }
      return true;
    }

    var tries = 0;
    (function loop() {
      if (ensure() || ++tries > 20) return;
      setTimeout(loop, 250);
    })();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensure);
    document.addEventListener('change', function () { setTimeout(ensure, 300); }, true);
    document.addEventListener('shopify:section:load', function () { setTimeout(ensure, 0); });
  }
})();
